module.exports = __webpack_public_path__ + "img/arw-link-secondary.fa4272ba.svg";